import React from 'react'
import Logo from '../../images/shitface_logo.png'
import Main_Logo from '../../images/Main_Logo.png'
import {Facebook, Instagram, Youtube, Twitter, Send} from 'react-feather'
import { useState } from 'react';
import { XCircle, LogIn } from 'react-feather'
import { Modal, Button } from 'antd';
import Metamask from '../../images/metamask.png'

function HeaderMenu() {

    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => {
        setIsModalVisible(true);
      };
    
      const handleOk = () => {
        setIsModalVisible(false);
      };
    
      const handleCancel = () => {
        setIsModalVisible(false);
      };

    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-dark navbar-fixed-top custom_blue">
            <div className="container">
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo03" aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
                </button>
                <a className="navbar-brand" href="/"><img src={Main_Logo} /><img src={Logo} /></a>
                <div className="collapse navbar-collapse" id="navbarTogglerDemo03">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0 bold_text">
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo03" aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="d-flex justify-content-end m-2"><XCircle size={25} /></span>
                        </button>

                        <div className="hide-on-desktop">
                            <form>
                                <Button type="primary" className="custom_connect_button" onClick={showModal}>
                                    <LogIn size={18} style={{marginTop: '-3px', marginRight: '5px'}} />Connect
                                </Button>
                            </form>
                        </div>
                        
                        <li className="nav-item">
                            <a className="nav-link active" aria-current="page" href="#">Pools</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link active" href="#">Farms</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link active">Whitepaper</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link active">FAQ</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link active">Calculator</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link active">Official Website</a>
                        </li>

                        <div className="vr text-light"></div>

                        <div className="d-flex">
                            <li className="nav-item">
                                <a className="nav-link active social"><Facebook size={18} /></a>
                            </li>

                            <li className="nav-item">
                                <a className="nav-link active social"><Instagram size={18} /></a>
                            </li>

                            <li className="nav-item">
                                <a className="nav-link active social"><Youtube size={18} /></a>
                            </li>

                            <li className="nav-item">
                                <a className="nav-link active social"><Twitter size={18} /></a>
                            </li>

                            <li className="nav-item">
                                <a className="nav-link active social"><Send size={18} /></a>
                            </li>
                        </div>

                        <div className="vr text-light"></div>
                    </ul>

                    <div className="hide-on-mobile">
                        <form className="mt-1">
                            <Button type="primary" className="custom_connect_button" onClick={showModal}>
                                <LogIn size={18} style={{marginTop: '-3px', marginRight: '5px'}} />Connect
                            </Button>
                        </form>
                    </div>
                </div>
            </div>
            </nav>

            <Modal title="Connect" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} bodyStyle={{backgroundColor: "#ecfbfd"}} footer={null} style={{borderRadius: '10px'}}>
                <div className="text-center col-md-12">
                    <Button type="primary" className="custom_connect_button"><img src={Metamask} style={{width: '25px', marginRight: '5px'}} />Login with metamask</Button>
                </div>
            </Modal>
            
        </div>
    )
}

export default HeaderMenu
